{
  "cartDetails": {
    "id": "ID",
    "proceedToCheckout": "Proceed to Checkout",
    "cartName": "winkelwagen #{{code}}"
  },
  "cartItems": {
    "id": "ID",
    "description": "Omschrijving",
    "item": "aritkel",
    "itemPrice": "Prijs per stuk",
    "quantity": "Aantal",
    "quantityTitle": "The quantity represents the total number of this item in your cart.",
    "total": "Totaalprijs",
    "cartTotal": "winkelwagen totaal ({{count}} aritkel)",
    "cartTotal_plural": "winkelwagen totaal ({{count}} artikelen)"
  },
  "orderCost": {
    "orderSummary": "Order Summary",
    "subtotal": "Subtotal after discounts:",
    "shipping": "Shipping:",
    "estimatedShipping": "Estimated shipping:",
    "discount": "You saved:",
    "salesTax": "Sales Tax:",
    "grossTax": "The order total does not include tax of",
    "grossIncludeTax": "The order total includes tax of",
    "total": "Totaal:",
    "toBeDetermined": "TBD"
  },
  "voucher": {
    "coupon": "Have a coupon?",
    "coupon_plural": "Coupon codes",
    "apply": "Overnemen",
    "placeholder": "Promo code",
    "applyVoucherSuccess": "{{voucherCode}} has been applied.",
    "removeVoucherSuccess": "{{voucherCode}} has been removed.",
    "anchorLabel": "Enter or remove your coupon code",
    "vouchersApplied": "Applied coupons",
    "availableCoupons": "Available coupons",
    "availableCouponsLabel": "You can add these coupons to this order."
  },
  "saveForLaterItems": {
    "itemTotal": "Saved for later ({{count}} item)",
    "itemTotal_plural": "Saved for later ({{count}} items)",
    "cartTitle": "Cart",
    "saveForLater": "Save For Later",
    "moveToCart": "Move To Cart",
    "stock": "Stock",
    "forceInStock": "In Stock"
  }
}
